import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquidraggable',
	templateUrl:'./JQUIDraggablePage.html',
	styles: [],
	styleUrls:['./JQUIDraggablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDraggablePage
{
	mdContent_198 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.draggable.JQUIDraggable;
\`\`\``;
	mdContent_199 = `\`\`\`java
new JQUIDraggable&lt;&gt;()
\`\`\``;
	mdContent_200 = `\`\`\`java
var box = new JQUIDraggable<>();
box.setText("Drag me!");
box.getOptions().setAxis("x");
\`\`\``;
}
